import { Box } from "@mui/material";
import { Link } from "react-router-dom";
import { CustomButton } from "../../../components/Buttons";
import { FEEDBACK_LINK } from "../../Feedback/constants";

const CallToAction = ({ username }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      gap={2}
      py={20}
    >
      <CustomButton
        href={`/member/${username}`}
        sx={{
          backgroundColor: FEEDBACK_LINK,
        }}
      >
        View Profile Main Page
      </CustomButton>
      <Link
        to="/feedback/topic/weekRecap"
        style={{ color: FEEDBACK_LINK, textDecoration: 'underline', fontWeight: 700 }}
      >
        Give feedback on Week Recap
      </Link>
    </Box>
  );
}

export default CallToAction;
